import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpResponse,
  HttpInterceptor
} from '@angular/common/http';
import { tap, catchError } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { throwError } from 'rxjs';
import { ToastService } from 'ng-zorro-antd-mobile';
import { environment } from 'src/environments/environment';

@Injectable()
export class NotificationInterceptor implements HttpInterceptor {

  constructor(
    private toast: ToastService,
  ) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // return next.handle(request);
    return next.handle(req).pipe(
      tap((event: HttpEvent<any>) => {
        if (
          event instanceof HttpResponse &&
          event.status >= 200 &&
          event.status < 300
        ) {  }
      }),
      catchError((ev: any) => {
        if (ev.error && ev.error.message) {
          if (ev.status === 401) {

            // location.href = environment.WECHAT_OAUTH_HOST + '&state=' + encodeURI(location.pathname);
          }
          if (ev.status !== 401) {
            this.toast.show(ev.error.message, 3000);

          }
        }
        return throwError(ev);
      })
    );
  }
}
